import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const incluye = ['Los 6 tomos completos del método Boxeo 360', 'Los 5 bonos: planillas, +100 ejercicios, corrección, evaluación y diario', 'Acceso inmediato por email en PDF, para celular, tablet o imprimir', 'Actualizaciones futuras del material sin costo extra'];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-zinc-950 py-16 lg:py-24" aria-labelledby="oferta-titulo" data-id="element-84" data-mp="ifb117d24lwy">
      <div className="mx-auto max-w-3xl px-6" data-id="element-85" data-mp="rdenq6zs3oqc">
        <h2 id="oferta-titulo" className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-86" data-mp="repodxxxggd8">
          Pack Boxeo 360 completo
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-base leading-relaxed text-zinc-400" data-id="element-87" data-mp="2t742sn19j2ow">
          Ideal para profes que están empezando a ordenar su gimnasio y quieren un método propio
          desde la primera clase.
        </p>

        <div className="mt-10 rounded-xl bg-zinc-900 p-8 shadow-2xl shadow-black/70 ring-1 ring-amber-400/30 sm:p-10" data-id="element-88" data-mp="xx1vhp0nu41b">
          <p className="inline-flex items-center gap-2 rounded-md bg-red-600/15 px-3 py-1 text-xs font-bold uppercase tracking-wide text-red-400" data-id="element-89" data-mp="swxdfuk3t18z">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="ou0v84yh775k" />
            Oferta de lanzamiento
          </p>

          <div className="mt-6 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-91" data-mp="1gn9wo1ksukev">
            <span className="font-display text-5xl leading-none text-white sm:text-6xl" data-id="element-92" data-mp="1go2xyn0zohpm">
              $18.990
            </span>
            <span className="pb-1 text-sm font-semibold uppercase tracking-wide text-zinc-400" data-id="element-93" data-mp="17mv9sxs6sx99">
              ARS · pago único
            </span>
          </div>

          <ul className="mt-8 space-y-3.5 border-t border-zinc-800 pt-8" data-id="element-94" data-mp="17ub4kbs20yz">
            {incluye.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-zinc-300" data-id="element-95" data-mp="3sewzl408dt5i">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" aria-hidden="true" data-id="element-96" data-mp="3trwryw36d55r" />
                {item}
              </li>)}
          </ul>

          <div className="mt-9 flex flex-col items-center gap-3" data-id="element-97" data-mp="3ksjfrvno22hc">
            <CtaButton origin="oferta" className="w-full" data-id="element-98" data-mp="3oudevzi7qyfe">
              Quiero el pack Boxeo 360 ahora
            </CtaButton>
            <Countdown data-id="element-99" data-mp="3b2q5qz369vf7" />
          </div>
        </div>
      </div>
    </section>;
}